import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";

const CardSlider = () => {
  const services = [
    { name: "AI Agents", description: "Talk with AI-powered agents.", image: "/assets/img2.jpg" },
    { name: "Face Recognition", description: "Advanced AI for facial analysis.", image: "/assets/img6.jpg" },
    { name: "OCR", description: "Extract text from images seamlessly.", image: "/assets/img1.webp" },
    { name: "Object Detection", description: "Detect objects accurately.", image: "/assets/img3.jpg" },
    { name: "Text Summarization", description: "Summarize text into key insights.", image: "/assets/img7.avif" },
  ];

  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;
    let interval;

    if (slider) {
      interval = setInterval(() => {
        slider.scrollBy({ top: 200, behavior: "smooth" });

        if (slider.scrollTop + slider.offsetHeight >= slider.scrollHeight) {
          slider.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 4000);
    }

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative bg-black text-white py-12 sm:py-16">
      {/* Main Container */}
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-center space-y-8 md:space-y-0 md:space-x-8 px-4 sm:px-8">
        
        {/* Big Card */}
        <div 
          className="w-full md:w-2/3 h-[400px] sm:h-[500px] md:h-[600px] bg-cover bg-center rounded-3xl flex flex-col justify-end p-6 sm:p-8"
          style={{ backgroundImage: `url(/assets/explore.webp)` }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold">Explore Our AI Services</h2>
          <p className="text-gray-300 mt-2 text-sm sm:text-base">Discover the power of AI with our cutting-edge services.</p>
        </div>

        {/* Vertical Scrollable Small Cards */}
        <div
          className="w-full md:w-1/3 max-h-[500px] md:h-[600px] overflow-y-scroll relative rounded-2xl"
          ref={sliderRef}
          style={{ scrollSnapType: "y mandatory", scrollbarWidth: "none" }}
        >
          <motion.div className="flex flex-col space-y-6 sm:space-y-8" initial={{ y: 0 }} whileTap={{ cursor: "grabbing" }}>
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="relative w-full h-[180px] sm:h-[200px] shadow-lg overflow-hidden flex-shrink-0 transform transition-transform duration-300 hover:scale-105 rounded-2xl"
                style={{ scrollSnapAlign: "start" }}
              >
                {/* Background Image */}
                <div className="w-full h-full rounded-2xl bg-cover bg-center" style={{ backgroundImage: `url(${service.image})` }}></div>

                {/* Overlay Content */}
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-4">
                  <h3 className="text-lg sm:text-xl font-bold">{service.name}</h3>
                  <p className="text-gray-300 mt-1 sm:mt-2 text-xs sm:text-sm">{service.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CardSlider;


// import React, { useRef } from "react";
// import { motion } from "framer-motion";
// import { useEffect } from "react";

// const CardSlider = () => {
//   const services = [
//     {
//       name: "AI Agents",
//       description: "Talk with Agents.",
//       image: "/assets/img2.jpg",
//     },
//     {
//       name: "Face Recognition",
//       description: "Advanced AI for facial analysis.",
//       image: "/assets/img6.jpg",
//     },
//     {
//       name: "OCR",
//       description: "Text extraction from images.",
//       image: "/assets/img1.webp",
//     },
//     {
//       name: "Object Detection",
//       description: "Identify objects seamlessly.",
//       image: "/assets/img3.jpg",
//     },
//     {
//       name: "Text Summarization",
//       description: "Turn lengthy text into key ideas.",
//       image: "/assets/img7.avif",
//     },
    
//   ];

//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const slider = sliderRef.current;
//     let interval;

//     if (slider) {
//       interval = setInterval(() => {
//         slider.scrollBy({ top: 200, behavior: "smooth" }); // Scroll vertically

//         if (
//           slider.scrollTop + slider.offsetHeight >=
//           slider.scrollHeight
//         ) {
//           slider.scrollTo({ top: 0, behavior: "smooth" }); // Reset to top
//         }
//       }, 4000); // Auto-scroll every 4 seconds
//     }

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="relative bg-black text-white py-16">
//       {/* Main Container */}
//       <div className="container mx-auto flex flex-col md:flex-row items-center justify-center space-y-8 md:space-y-0 md:space-x-8">
//         {/* Big Card */}
//         <div className="w-full md:w-3/2 h-[600px] bg-cover bg-center rounded-3xl flex flex-col justify-end p-8" style={{ backgroundImage: `url(/assets/explore.webp)` }}>
//           <h2 className="text-4xl font-bold">Explore Our AI Services</h2>
//           <p className="text-gray-300 mt-2">Discover the power of AI with our cutting-edge services.</p>
//         </div>

//         {/* Vertical Scrollable Small Cards */}
//         <div
//           className="w-full md:w-1/3 h-[600px] overflow-y-scroll relative"
//           ref={sliderRef}
//           style={{
//             scrollSnapType: "y mandatory",
//             scrollbarWidth: "none",
//           }}
//         >
//           <motion.div
//             className="flex flex-col space-y-8"
//             initial={{ y: 0 }}
//             whileTap={{ cursor: "grabbing" }}
//           >
//             {services.map((service, index) => (
//               <motion.div
//                 key={index}
//                 className="relative w-full h-[200px] shadow-lg overflow-hidden flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
//                 style={{
//                   scrollSnapAlign: "start",
//                 }}
//               >
//                 {/* Background Image */}
//                 <div
//                   className="w-full h-full rounded-2xl bg-cover bg-center"
//                   style={{ backgroundImage: `url(${service.image})` }}
//                 ></div>

//                 {/* Overlay Content */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-4">
//                   <h3 className="text-xl font-bold">{service.name}</h3>
//                   <p className="text-gray-300 mt-2 text-sm">{service.description}</p>
//                 </div>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CardSlider;


// import React, { useRef } from "react";
// import { motion } from "framer-motion";
// import { useEffect } from "react";

// const CardSlider = () => {
//   const services = [
//     {
//       name: "Face Recognition",
//       description: "Advanced AI for facial analysis.",
//       image: "/assets/face.png",
//     },
//     {
//       name: "OCR",
//       description: "Text extraction from images.",
//       image: "/assets/img2.avif",
//     },
//     {
//       name: "Object Detection",
//       description: "Identify objects seamlessly.",
//       image: "/assets/object_detect.avif",
//     },
//     {
//       name: "Text Summarization",
//       description: "Turn lengthy text into key ideas.",
//       image: "/assets/text_summry.jpg",
//     },
//     {
//       name: "Language Translation",
//       description: "AI-powered translations.",
//       image: "/assets/language.avif",
//     },
//     {
//       name: "Sentiment Analysis",
//       description: "Understand emotions in data.",
//       image: "/assets/sentiment.jpg",
//     },
//   ];

//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const slider = sliderRef.current;
//     let interval;

//     if (slider) {
//       interval = setInterval(() => {
//         slider.scrollBy({ left: slider.offsetWidth, behavior: "smooth" });

//         if (
//           slider.scrollLeft + slider.offsetWidth >=
//           slider.scrollWidth
//         ) {
//           slider.scrollTo({ left: 0, behavior: "smooth" });
//         }
//       }, 4000); // Auto-scroll every 4 seconds
//     }

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="relative bg-black text-white py-16">
//       {/* Main Container */}
//       <div className="container mx-auto flex flex-col md:flex-row items-center justify-center space-y-8 md:space-y-0 md:space-x-8">
//         {/* Big Card */}
//         <div className="w-full md:w-1/2 h-[500px] bg-cover bg-center rounded-3xl flex flex-col justify-end p-8" style={{ backgroundImage: `url(/assets/ai_services.jpg)` }}>
//           <h2 className="text-4xl font-bold">Explore Our AI Services</h2>
//           <p className="text-gray-300 mt-2">Discover the power of AI with our cutting-edge services.</p>
//         </div>

//         {/* Scrollable Small Cards */}
//         <div
//           className="w-full md:w-1/2 overflow-hidden relative"
//           ref={sliderRef}
//           style={{
//             scrollSnapType: "x mandatory",
//             overflowX: "scroll",
//             scrollbarWidth: "none",
//           }}
//         >
//           <motion.div
//             className="flex space-x-6"
//             initial={{ x: 0 }}
//             whileTap={{ cursor: "grabbing" }}
//           >
//             {services.map((service, index) => (
//               <motion.div
//                 key={index}
//                 className="relative min-w-[200px] h-[300px] shadow-lg overflow-hidden flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
//                 style={{
//                   scrollSnapAlign: "start",
//                 }}
//               >
//                 {/* Background Image */}
//                 <div
//                   className="w-full h-full rounded-3xl bg-cover bg-center"
//                   style={{ backgroundImage: `url(${service.image})` }}
//                 ></div>

//                 {/* Overlay Content */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-4">
//                   <h3 className="text-xl font-bold">{service.name}</h3>
//                   <p className="text-gray-300 mt-2 text-sm">{service.description}</p>
//                 </div>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CardSlider;



// import React, { useRef } from "react";
// import { motion } from "framer-motion";
// import { useEffect } from "react";

// const CardSlider = () => {
//   const services = [
//     {
//       name: "Face Recognition",
//       description: "Advanced AI for facial analysis.",
//       image: "/assets/face.png",
//     },
//     {
//       name: "OCR",
//       description: "Text extraction from images.",
//       image: "/assets/img2.avif",
//     },
//     {
//       name: "Object Detection",
//       description: "Identify objects seamlessly.",
//       image: "/assets/object_detect.avif",
//     },
//     {
//       name: "Text Summarization",
//       description: "Turn lengthy text into key ideas.",
//       image: "/assets/text_summry.jpg",
//     },
//     {
//       name: "Language Translation",
//       description: "AI-powered translations.",
//       image: "/assets/language.avif",
//     },
//     {
//       name: "Sentiment Analysis",
//       description: "Understand emotions in data.",
//       image: "/assets/sentiment.jpg",
//     },
//   ];

//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const slider = sliderRef.current;
//     let interval;

//     if (slider) {
//       interval = setInterval(() => {
//         slider.scrollBy({ left: slider.offsetWidth, behavior: "smooth" });

//         if (
//           slider.scrollLeft + slider.offsetWidth >=
//           slider.scrollWidth
//         ) {
//           slider.scrollTo({ left: 0, behavior: "smooth" });
//         }
//       }, 4000); // Auto-scroll every 4 seconds
//     }

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="relative bg-black text-white py-16">
//       {/* Slider Title */}
//       <h2 className="text-4xl font-bold text-center mb-8">
//         Explore Our AI Services
//       </h2>

//       {/* Slider Container */}
//       <div
//         className="relative overflow-hidden flex items-center justify-center"
//         ref={sliderRef}
//         style={{
//           scrollSnapType: "x mandatory",
//           overflowX: "scroll",
//           scrollbarWidth: "none",
//         }}
//       >
//         <motion.div
//           className="flex space-x-6"
//           initial={{ x: 0 }}
//           whileTap={{ cursor: "grabbing" }}
//         >
//           {services.map((service, index) => (
//             <motion.div
//               key={index}
//               className="relative min-w-[80vw] md:min-w-[60vw] max-w-[60vw] h-[400px] md:h-[500px]  shadow-lg overflow-hidden flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
//               style={{
//                 scrollSnapAlign: "start",
//               }}
//             >
//               {/* Background Image */}
//               <div
//                 className="w-full h-full rounded-3xl bg-cover bg-center"
//                 style={{ backgroundImage: `url(${service.image})` }}
//               ></div>

//               {/* Overlay Content */}
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6">
//                 <h3 className="text-3xl font-bold">{service.name}</h3>
//                 <p className="text-gray-300 mt-2">{service.description}</p>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>

//     </div>
//   );
// };

// export default CardSlider;
